import { Loader } from 'hfs-common-ui';
import * as S from './styled';

const PageLoader = () => (
  <S.LoaderContainer>
    <Loader size="large" />
  </S.LoaderContainer>
);
export default PageLoader;
